<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'

export default {
  name: 'publicParamsDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: {}
    }
  },
  mounted() {
    const { id } = this.$route.query
    id &&
      api.command.getDetail.call(this, {
        url: `/param/view/${id}`
      })
  },
  methods: {
    getForm1() {
      return {
        title: '参数信息',
        type: 'cardForm',
        gutter: 15,
        data: [
          {
            name: '参数名称',
            type: 'input',
            cols: 12,
            key: 'publicName',
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          },
          {
            name: '键',
            type: 'input',
            cols: 12,
            key: 'publicKey',
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          }
        ]
      }
    },

    getForm2() {
      return {
        title: '参数设置',
        type: 'cardForm',
        gutter: 15,
        data: [
          {
            name: '内部参数',
            type: 'select',
            cols: 12,
            key: 'internal',
            defaultValue: '1',
            typeData: [
              {
                name: '是',
                value: '0'
              },
              {
                name: '否',
                value: '1'
              }
            ]
          },
          {
            name: '系统内置',
            type: 'select',
            cols: 12,
            key: 'sys',
            defaultValue: '0',
            typeData: [
              {
                name: '是',
                value: '1'
              },
              {
                name: '否',
                value: '0'
              }
            ]
          },
          {
            name: '系统值',
            type: 'input',
            key: 'publicValue',
            cols: 24,
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          },
          {
            name: '参数描述',
            type: 'textArea',
            cols: 12,
            key: 'remark'
          }
        ]
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: data => {
            console.log(data)
            api.command[this.detail.publicId ? 'edit' : 'create']
              .call(this, {
                url: '/param',
                params: {
                  ...data
                },
                isPost: false
              })
              .then(result => {
                this.$router.push('/system/publicParams')
              })
          }
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => {
            this.$router.push('/system/publicParams')
          }
        }
      ]

      return {
        left
      }
    }
  },
  render() {
    return <DetailFormGroup foot={this.getFoot()} form={this.detail} data={[this.getForm1(), this.getForm2()]} />
  }
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
